import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded'
import { AppBar, Avatar, Badge, Box, IconButton, ListItemIcon, Menu, Tooltip } from '@mui/material'
import Toolbar from '@mui/material/Toolbar'
import React from 'react'
import Label from '../Label'
import { useAuthContext } from 'contexts/auth.context'
import MenuItem from '@mui/material/MenuItem'
import { useAuth } from 'react-oidc-context'
import Logout from '@mui/icons-material/Logout'
import { useNavigate } from 'react-router-dom'
import { useNotifications } from 'pages/SearchNotifications/hook/notifications.hook'
import logoBranco from 'assets/logo-mac-branco.png'
import { StyledImg } from 'components/Header/style'
import { FotoUsuario } from 'components/FotoUsuario'

type HeaderProps = {
  onMenuClick: () => void
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { usuarioPossuiNotificacao } = useNotifications()
  const { user } = useAuthContext()
  const navigate = useNavigate()
  const { signoutRedirect } = useAuth()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <AppBar position='fixed'>
      <Toolbar variant='dense'>
        <IconButton edge='start' color='inherit' sx={{ mr: 2 }} onClick={onMenuClick}>
          <MenuRoundedIcon />
        </IconButton>

        <Box display={'flex'} flexGrow={1} alignItems={'center'}>
          <StyledImg src={logoBranco} alt={'mprj-logo-branco'} />
        </Box>

        <Label text={user?.name} v='body2' sx={{ mr: '1rem' }} />

        <IconButton color='inherit' size='small' onClick={() => navigate('/notificacoes')}>
          <Badge color={'secondary'} variant='dot' invisible={!usuarioPossuiNotificacao}>
            <NotificationsRoundedIcon />
          </Badge>
        </IconButton>

        <Tooltip title='Menu'>
          <IconButton
            onClick={handleClick}
            size='small'
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
          >
            <FotoUsuario />
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={() => signoutRedirect()}>
            <ListItemIcon>
              <Logout fontSize='small' />
            </ListItemIcon>
            Sair
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  )
}

export default Header
